export default {"src":"/_next/static/media/whatsapp_icon.848b789d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};